module.exports = __webpack_public_path__ + "6cee748923dd8ff911c2754fdde1c117.svg";